import React from 'react';

/** Lazy ClientComputedTrainingCoursesInProgress (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedTrainingCoursesInProgress = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-training-courses-in-progress' */
            './ClientComputedTrainingCoursesInProgress'
        ),
);
